(function () {
  'use strict';
  if (window.__etkLanguageFixes) return;
  window.__etkLanguageFixes = true;
  var words = window.ETKText || {};
  var colorKeys = {noir:'black',black:'black',blanc:'white',white:'white',gris:'grey',grey:'grey',gray:'grey',rose:'pink',pink:'pink',rouge:'red',red:'red',violet:'purple',purple:'purple',bleu:'blue',blue:'blue',vert:'green',green:'green',vanilla:'vanilla'};
  function translateColor(value) {
    return value.split(/(\s*[·/]\s*)/).map(function (part) {
      var key=colorKeys[part.trim().toLowerCase()];
      return key && words[key] ? part.replace(part.trim(),words[key]) : part;
    }).join('');
  }
  var optionNames={taille:'size',size:'size',größe:'size',velikost:'size',talla:'size','tamaño':'size',taglia:'size',couleur:'color',coloris:'color',color:'color',colour:'color',colore:'color',farbe:'color',barva:'color',impression:'print',print:'print',stampa:'print',druck:'print',potisk:'print','impresión':'print',style:'style',styl:'style',stil:'style',stile:'style',estilo:'style'};
  function optionValue(value,key) {
    if(key==='color') return translateColor(value);
    if(key==='print') {
      if(/^recto\s*\+\s*verso$/i.test(value)) return words.frontBack||value;
      if(/^recto$/i.test(value)) return words.front||value;
    }
    if(key==='style' && /^régular$/i.test(value)) return words.regular||value;
    return value;
  }
  function optionLine(value) {
    return value.split(/(,\s*)/).map(function(part){
      var m=part.match(/^([^:]+):\s*(.*)$/); if(!m) return part;
      var key=optionNames[m[1].trim().toLowerCase()]; if(!key||!words[key]) return part;
      return words[key]+': '+optionValue(m[2],key);
    }).join('');
  }
  function textOnly(element,transform) {
    Array.from(element.childNodes).forEach(function(node){
      if(node.nodeType!==3) return;
      var next=transform(node.textContent);
      if(next!==node.textContent) node.textContent=next;
    });
  }
  function productLabels() {
    document.querySelectorAll('.product__info-container fieldset.product-form__input:not(.add-new)').forEach(function(field){
      var legend=field.querySelector('legend'); if(!legend) return;
      var label=legend.querySelector('.etk-lbl')||legend;
      textOnly(label,function(value){var key=optionNames[value.trim().replace(/:$/,'').toLowerCase()];return key&&words[key]?value.replace(value.trim(),words[key]+(/:$/.test(value.trim())?':':'')):value;});
      if(/impression|print|stampa|druck|potisk|impresión/i.test(legend.textContent)) field.querySelectorAll('label').forEach(function(el){textOnly(el,function(v){return optionValue(v.trim(),'print');});});
    });
    [['.etk-titre-avis','reviewsHeading'],['.etk-soustitre-avis','reviewsSubtitle']].forEach(function(pair){
      document.querySelectorAll(pair[0]).forEach(function(el){if(words[pair[1]]&&el.textContent!==words[pair[1]])el.textContent=words[pair[1]];});
    });
    document.querySelectorAll('.etk-sr-txt').forEach(function(el){textOnly(el,function(v){return v.replace(/avis clients/gi,words.reviewsHeading||'avis clients');});});
  }
  var cartRoot=null,cartObserver=null,cartPending=false;
  function cartLabels(root) {
    root.querySelectorAll('.upcart-public-component-product-tile__variant .upcart-internal-cart-items__key-value-pair').forEach(function(el){textOnly(el,optionLine);});
    root.querySelectorAll('.etk-modifier-visuel').forEach(function(el){if(words.editDesign&&el.textContent!==words.editDesign)el.textContent=words.editDesign;});
    root.querySelectorAll('select option[value]').forEach(function(option){textOnly(option,function(value){return value.split(/(\s*\/\s*)/).map(function(part){var trimmed=part.trim();var translated=optionValue(trimmed,'print');if(translated===trimmed)translated=translateColor(trimmed);return part.replace(trimmed,translated);}).join('');});});
  }
  function connectCart() {
    var host=document.getElementById('upCart');var root=host&&host.shadowRoot;
    if(!root||root===cartRoot) return;
    if(cartObserver)cartObserver.disconnect();cartRoot=root;cartLabels(root);
    cartObserver=new MutationObserver(function(){if(cartPending)return;cartPending=true;requestAnimationFrame(function(){cartPending=false;if(cartRoot)cartLabels(cartRoot);});});
    cartObserver.observe(root,{childList:true,subtree:true,characterData:true});
  }
  function colors() {
    document.querySelectorAll('.grid-swatch[aria-label]').forEach(function(swatch){
      var original=swatch.dataset.etkOriginalColor || swatch.getAttribute('aria-label');
      swatch.dataset.etkOriginalColor=original;
      var translated=translateColor(original);
      if(swatch.getAttribute('aria-label')!==translated) swatch.setAttribute('aria-label',translated);
      if(swatch.getAttribute('title')!==translated) swatch.setAttribute('title',translated);
    });
    document.querySelectorAll('fieldset:has(input.color-swatch-input)').forEach(function (field) {
      var legend=field.querySelector('legend');
      if(!legend) return;
      var selected=legend.querySelector('[id^="selected-"], [data-selected-value], .etk-val');
      var checked=field.querySelector('input.color-swatch-input:checked');
      if(selected && checked) {
        var next=translateColor(checked.value);
        if(selected.textContent!==next) selected.textContent=next;
      }
      var wrapper=legend.querySelector('.etk-coul') || legend;
      Array.from(wrapper.childNodes).filter(function(n){return n.nodeType===3;}).forEach(function(n){
        if(/^(Coloris|Couleur|Color|Colour|Colore|Farbe|Barva)\s*:?[\s·]*$/i.test(n.textContent.trim()) && words.color) {
          var next=words.color+(wrapper===legend?': ':'');
          if(n.textContent!==next) n.textContent=next;
        }
      });
      field.querySelectorAll('label.color-swatch').forEach(function(label){
        var input=document.getElementById(label.htmlFor);
        if(!input) return;
        var value=translateColor(input.value);
        if(label.getAttribute('title')!==value) label.setAttribute('title',value);
        if(label.getAttribute('aria-label')!==value) label.setAttribute('aria-label',value);
      });
    });
  }
  var ids={wrapper:'shopify-pc__prefs',dialog:'shopify-pc__prefs__dialog',overlay:'shopify-pc__prefs__overlay',close:'shopify-pc__prefs__header-close',decline:'shopify-pc__prefs__header-decline'};
  var forwarding=false;
  function hasPriorConsent() {
    var api=window.Shopify && window.Shopify.customerPrivacy;
    if(!api || typeof api.currentVisitorConsent!=='function') return null;
    try {
      var state=api.currentVisitorConsent();
      return ['analytics','marketing','preferences'].some(function(key){return state[key]==='yes'||state[key]==='no';});
    } catch(error) { return null; }
  }
  function dismiss() {
    var close=document.getElementById(ids.close);
    var decline=document.getElementById(ids.decline);
    var target=hasPriorConsent()===false ? decline : close;
    if(!target) return;
    forwarding=true;
    try { target.click(); } finally { forwarding=false; }
  }
  function cookieDialog() {
    var modal=document.getElementById(ids.dialog);
    if(!modal) return;
    var close=document.getElementById(ids.close);
    if(close && words.close && close.getAttribute('aria-label')!==words.close) close.setAttribute('aria-label',words.close);
    if(!modal.querySelector('[data-etk-cookie-explanation]') && words.dismiss) {
      var note=document.createElement('p');
      note.dataset.etkCookieExplanation=''; note.textContent=words.dismiss;
      note.style.cssText='font-size:13px;line-height:1.5;margin:12px 0;';
      var header=modal.querySelector('header');
      if(header) {
        var title=header.querySelector('h2');
        if(title) note.style.color=window.getComputedStyle(title).color;
        header.appendChild(note);
      }
    }
    var preferenceLabel=modal.querySelector('label[for="shopify-pc__prefs__preferences-input"]');
    if(preferenceLabel && words.preferences) Array.from(preferenceLabel.childNodes).forEach(function(node){
      if(node.nodeType===3 && /^la santità$/i.test(node.textContent.trim())) node.textContent=words.preferences;
    });
    if(modal.dataset.etkDismissBound) return;
    modal.dataset.etkDismissBound='true';
    var wrapper=document.getElementById(ids.wrapper);
    if(wrapper) wrapper.addEventListener('click',function(event){
      if(event.target.id===ids.overlay || event.target===wrapper) {event.preventDefault();event.stopPropagation();dismiss();}
    });
    modal.addEventListener('click',function(event){
      if(!forwarding && event.target.closest('#'+ids.close) && hasPriorConsent()===false) {
        event.preventDefault();event.stopImmediatePropagation();dismiss();
      }
    },true);
    modal.addEventListener('keydown',function(event){
      if(event.key==='Escape') {event.preventDefault();event.stopImmediatePropagation();dismiss();}
    },true);
  }
  function preferencesLink() {
    if(document.querySelector('[data-etk-cookie-link]') || !words.cookies) return;
    var footer=document.querySelector('footer, [id$="__etilik_footer"]');
    if(!footer) return;
    var link=document.createElement('a');
    link.href='#shopifyReshowConsentBanner';link.dataset.etkCookieLink='';link.textContent=words.cookies;
    link.addEventListener('click',function(event){
      if(window.privacyBanner && typeof window.privacyBanner.showPreferences==='function') {
        event.preventDefault();
        window.privacyBanner.showPreferences().catch(function(){window.location.hash='shopifyReshowConsentBanner';});
      }
    });
    link.style.cssText='display:inline-block;margin:16px 0;text-decoration:underline;';
    footer.appendChild(link);
  }
  function run(){colors();productLabels();connectCart();cookieDialog();preferencesLink();}
  var pending=false;
  var observer=new MutationObserver(function(){
    if(pending) return;pending=true;
    requestAnimationFrame(function(){pending=false;run();});
  });
  function start(){
    run();observer.observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('change',colors);
    function retryCart(){[0,250,1000,3000].forEach(function(delay){setTimeout(connectCart,delay);});}
    document.addEventListener('click',function(event){if(event.target.closest('#cart-icon-bubble'))retryCart();});
    retryCart();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
